export default __webpack_public_path__ + "static/media/EAST2480.34I-34281_-18535_0.c7508871.jpg";